export const ADMIN = 'admin'
export const OPERATOR = 'operator'
export const API_CLIENT = 'api_client'
export const AGENCY = 'agency'
